import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _7d035078 = () => interopDefault(import('..\\..\\..\\pages\\content-load-error.vue' /* webpackChunkName: "pages/content-load-error" */))
const _66576c5c = () => interopDefault(import('..\\..\\..\\pages\\forgot-password.vue' /* webpackChunkName: "pages/forgot-password" */))
const _18db573e = () => interopDefault(import('..\\..\\..\\pages\\go-to-app.vue' /* webpackChunkName: "pages/go-to-app" */))
const _33d0213c = () => interopDefault(import('..\\..\\..\\pages\\home.vue' /* webpackChunkName: "pages/home" */))
const _0a6a3914 = () => interopDefault(import('..\\..\\..\\pages\\login.vue' /* webpackChunkName: "pages/login" */))
const _2b42ad7e = () => interopDefault(import('..\\..\\..\\pages\\login-guest.vue' /* webpackChunkName: "pages/login-guest" */))
const _a8bad866 = () => interopDefault(import('..\\..\\..\\pages\\logout.vue' /* webpackChunkName: "pages/logout" */))
const _e97a1340 = () => interopDefault(import('..\\..\\..\\pages\\maintenance.vue' /* webpackChunkName: "pages/maintenance" */))
const _59182ed3 = () => interopDefault(import('..\\..\\..\\pages\\my-account\\index.vue' /* webpackChunkName: "pages/my-account/index" */))
const _5a3b3b62 = () => interopDefault(import('..\\..\\..\\pages\\my-account\\index\\index.vue' /* webpackChunkName: "pages/my-account/index/index" */))
const _409c0f31 = () => interopDefault(import('..\\..\\..\\pages\\my-account\\index\\address.vue' /* webpackChunkName: "pages/my-account/index/address" */))
const _37c8839a = () => interopDefault(import('..\\..\\..\\pages\\my-account\\index\\devices.vue' /* webpackChunkName: "pages/my-account/index/devices" */))
const _30dbbca4 = () => interopDefault(import('..\\..\\..\\pages\\my-account\\index\\password.vue' /* webpackChunkName: "pages/my-account/index/password" */))
const _36e34c43 = () => interopDefault(import('..\\..\\..\\pages\\my-account\\index\\payment.vue' /* webpackChunkName: "pages/my-account/index/payment" */))
const _0c5030bc = () => interopDefault(import('..\\..\\..\\pages\\my-account\\index\\plan.vue' /* webpackChunkName: "pages/my-account/index/plan" */))
const _65fdc068 = () => interopDefault(import('..\\..\\..\\pages\\my-courses\\index.vue' /* webpackChunkName: "pages/my-courses/index" */))
const _6ad6cf1a = () => interopDefault(import('..\\..\\..\\pages\\my-courses\\index\\index.vue' /* webpackChunkName: "pages/my-courses/index/index" */))
const _7b316013 = () => interopDefault(import('..\\..\\..\\pages\\my-courses\\index\\completed.vue' /* webpackChunkName: "pages/my-courses/index/completed" */))
const _7e695a9d = () => interopDefault(import('..\\..\\..\\pages\\my-courses\\index\\in-progress.vue' /* webpackChunkName: "pages/my-courses/index/in-progress" */))
const _6050b630 = () => interopDefault(import('..\\..\\..\\pages\\my-courses\\index\\new.vue' /* webpackChunkName: "pages/my-courses/index/new" */))
const _87bc5ffc = () => interopDefault(import('..\\..\\..\\pages\\my-courses\\index\\_id.vue' /* webpackChunkName: "pages/my-courses/index/_id" */))
const _c25739d4 = () => interopDefault(import('..\\..\\..\\pages\\my-list\\index.vue' /* webpackChunkName: "pages/my-list/index" */))
const _2a3639fa = () => interopDefault(import('..\\..\\..\\pages\\purchases\\index.vue' /* webpackChunkName: "pages/purchases/index" */))
const _02f918ec = () => interopDefault(import('..\\..\\..\\pages\\share.vue' /* webpackChunkName: "pages/share" */))
const _66adc1ec = () => interopDefault(import('..\\..\\..\\pages\\sign-up\\index.vue' /* webpackChunkName: "pages/sign-up/index" */))
const _63fc41af = () => interopDefault(import('..\\..\\..\\pages\\welcome.vue' /* webpackChunkName: "pages/welcome" */))
const _9dffc6d8 = () => interopDefault(import('..\\..\\..\\pages\\p\\privacy-policy.vue' /* webpackChunkName: "pages/p/privacy-policy" */))
const _52040358 = () => interopDefault(import('..\\..\\..\\pages\\p\\terms-of-use.vue' /* webpackChunkName: "pages/p/terms-of-use" */))
const _49f356e6 = () => interopDefault(import('..\\..\\..\\pages\\sign-up\\complete-profile.vue' /* webpackChunkName: "pages/sign-up/complete-profile" */))
const _3123405f = () => interopDefault(import('..\\..\\..\\pages\\index.vue' /* webpackChunkName: "pages/index" */))
const _4eb7eacc = () => interopDefault(import('..\\..\\..\\pages\\sign-up\\email-confirm\\_hash\\index.vue' /* webpackChunkName: "pages/sign-up/email-confirm/_hash/index" */))
const _1352a2d9 = () => interopDefault(import('..\\..\\..\\pages\\category\\_id\\index.vue' /* webpackChunkName: "pages/category/_id/index" */))
const _5fa5669a = () => interopDefault(import('..\\..\\..\\pages\\channel\\_id.vue' /* webpackChunkName: "pages/channel/_id" */))
const _41a075e1 = () => interopDefault(import('..\\..\\..\\pages\\reset-password\\_hash\\index.vue' /* webpackChunkName: "pages/reset-password/_hash/index" */))
const _0cddcac3 = () => interopDefault(import('..\\..\\..\\pages\\search\\_s\\index.vue' /* webpackChunkName: "pages/search/_s/index" */))
const _6e56737c = () => interopDefault(import('..\\..\\..\\pages\\view\\_id.vue' /* webpackChunkName: "pages/view/_id" */))
const _53c06000 = () => interopDefault(import('..\\..\\..\\pages\\view\\_id\\index.vue' /* webpackChunkName: "pages/view/_id/index" */))
const _48907aea = () => interopDefault(import('..\\..\\..\\pages\\view\\_id\\quiz\\index.vue' /* webpackChunkName: "pages/view/_id/quiz/index" */))
const _9409bcac = () => interopDefault(import('..\\..\\..\\pages\\view\\_id\\quiz\\finish.vue' /* webpackChunkName: "pages/view/_id/quiz/finish" */))
const _e621d3ca = () => interopDefault(import('..\\..\\..\\pages\\view\\_id\\quiz\\start.vue' /* webpackChunkName: "pages/view/_id/quiz/start" */))
const _192152b4 = () => interopDefault(import('..\\..\\..\\pages\\browse\\_type\\_id\\index.vue' /* webpackChunkName: "pages/browse/_type/_id/index" */))
const _1e4ddebe = () => interopDefault(import('..\\..\\..\\pages\\-not-found.vue' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/content-load-error",
    component: _7d035078,
    name: "content-load-error"
  }, {
    path: "/forgot-password",
    component: _66576c5c,
    name: "forgot-password"
  }, {
    path: "/go-to-app",
    component: _18db573e,
    name: "go-to-app"
  }, {
    path: "/home",
    component: _33d0213c,
    name: "home"
  }, {
    path: "/login",
    component: _0a6a3914,
    name: "login"
  }, {
    path: "/login-guest",
    component: _2b42ad7e,
    name: "login-guest"
  }, {
    path: "/logout",
    component: _a8bad866,
    name: "logout"
  }, {
    path: "/maintenance",
    component: _e97a1340,
    name: "maintenance"
  }, {
    path: "/my-account",
    component: _59182ed3,
    children: [{
      path: "",
      component: _5a3b3b62,
      name: "my-account-index"
    }, {
      path: "address",
      component: _409c0f31,
      name: "my-account-index-address"
    }, {
      path: "devices",
      component: _37c8839a,
      name: "my-account-index-devices"
    }, {
      path: "password",
      component: _30dbbca4,
      name: "my-account-index-password"
    }, {
      path: "payment",
      component: _36e34c43,
      name: "my-account-index-payment"
    }, {
      path: "plan",
      component: _0c5030bc,
      name: "my-account-index-plan"
    }]
  }, {
    path: "/my-courses",
    component: _65fdc068,
    children: [{
      path: "",
      component: _6ad6cf1a,
      name: "my-courses-index"
    }, {
      path: "completed",
      component: _7b316013,
      name: "my-courses-index-completed"
    }, {
      path: "in-progress",
      component: _7e695a9d,
      name: "my-courses-index-in-progress"
    }, {
      path: "new",
      component: _6050b630,
      name: "my-courses-index-new"
    }, {
      path: ":id",
      component: _87bc5ffc,
      name: "my-courses-index-id"
    }]
  }, {
    path: "/my-list",
    component: _c25739d4,
    name: "my-list"
  }, {
    path: "/purchases",
    component: _2a3639fa,
    name: "purchases"
  }, {
    path: "/share",
    component: _02f918ec,
    name: "share"
  }, {
    path: "/sign-up",
    component: _66adc1ec,
    name: "sign-up"
  }, {
    path: "/welcome",
    component: _63fc41af,
    name: "welcome"
  }, {
    path: "/p/privacy-policy",
    component: _9dffc6d8,
    name: "p-privacy-policy"
  }, {
    path: "/p/terms-of-use",
    component: _52040358,
    name: "p-terms-of-use"
  }, {
    path: "/sign-up/complete-profile",
    component: _49f356e6,
    name: "sign-up-complete-profile"
  }, {
    path: "/",
    component: _3123405f,
    name: "index"
  }, {
    path: "/sign-up/email-confirm/:hash",
    component: _4eb7eacc,
    name: "sign-up-email-confirm-hash"
  }, {
    path: "/category/:id",
    component: _1352a2d9,
    name: "category-id"
  }, {
    path: "/channel/:id?",
    component: _5fa5669a,
    name: "channel-id"
  }, {
    path: "/reset-password/:hash",
    component: _41a075e1,
    name: "reset-password-hash"
  }, {
    path: "/search/:s",
    component: _0cddcac3,
    name: "search-s"
  }, {
    path: "/view/:id?",
    component: _6e56737c,
    children: [{
      path: "",
      component: _53c06000,
      name: "view-id"
    }, {
      path: "quiz",
      component: _48907aea,
      name: "view-id-quiz"
    }, {
      path: "quiz/finish",
      component: _9409bcac,
      name: "view-id-quiz-finish"
    }, {
      path: "quiz/start",
      component: _e621d3ca,
      name: "view-id-quiz-start"
    }]
  }, {
    path: "/browse/:type?/:id",
    component: _192152b4,
    name: "browse-type-id"
  }, {
    path: "*",
    component: _1e4ddebe
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
